export const seminarsData = [
  {
    title: "ICAC Anti-Corruption Workshop",
    date: "10 Feb 2025",
    year: 2025,
    tag: "Integrity &Professional Development",
    id: "64",
    img: "s_11.png",
  },
  {
    title:
      "Seminar on Environmental, Social and Governance (ESG) and Sustainability",
    date: "11 April 2024",
    year: 2024,
    tag: "Environmental protection",
    id: "0",
    img: "s_1.png",
  },
  {
    title:
      "Seminar on Construction Testing: Towards Digitalisation and Automation in Construction Testing",
    date: "29 February 2024",
    year: 2024,
    tag: "Construction materials",
    id: "1",
    img: "s_2.png",
  },
  {
    title: "Metrology Symposium 2023",
    date: "24 October 2023",
    year: 2023,
    tag: "Metrology, Accreditation & Standards",
    id: "2",
    img: "s_3.png",
  },
  {
    title:
      "Seminar on Integrity and Professional Development in Testing and Certification Industry",
    date: "18 September 2023",
    year: 2023,
    tag: "Integrity & Professional Development",
    id: "3",
    img: "s_4.png",
  },
  {
    title: "World Accreditation Day Forum 2023",
    date: "16 June 2023",
    year: 2023,
    tag: "Construction materials",
    id: "4",
    img: "s_5.png",
  },
  {
    title:
      "Webinar on Application of Automation and Technology in Construction Materials Testing",
    date: "28 February 2023",
    year: 2023,
    tag: "Construction materials",
    id: "5",
    img: "s_6.png",
  },
  {
    title:
      "“Professional Integrity and Corruption Prevention in Testing and Certification” Webinar 2022",
    date: "30 August 2022",
    year: 2022,
    tag: "Integrity & Professional Development",
    id: "6",
    img: "s_7.png",
  },
  {
    title: "Metrology Symposium 2022",
    date: "12 August 2022",
    year: 2022,
    tag: "Metrology, Accreditation & Standards",
    id: "7",
    img: "s_8.png",
  },
  {
    title:
      "Webinar on Environmental, Social and Governance (ESG) and sustainability",
    date: "19 July 2022",
    year: 2022,
    tag: "Environmental protection",
    id: "8",
    img: "s_9.png",
  },
  {
    title:
      "Webinar on Latest Technology and Development in Building Inspection",
    date: "24 February 2022",
    year: 2022,
    tag: "Inspection",
    id: "9",
    img: "s_10.png",
  },
  {
    title: "Research and Development of Chinese Medicines 2021",
    date: "10 December 2021",
    year: 2021,
    tag: "Chinese medicines",
    id: "10",
  },
  {
    title: "Webinar on Information and Cyber Security",
    date: "28 July 2021",
    year: 2021,
    tag: "Information & Communication Technologies",
    id: "11",
  },
  {
    title:
      "“Professional Integrity and Corruption Prevention in Testing and Certification” Webinar 2021",
    date: "5 July 2021",
    year: 2021,
    tag: "Integrity & Professional Development",
    id: "12",
  },
  {
    title: "Metrology Symposium 2021",
    date: "28 May 2021",
    year: 2021,
    tag: "Metrology, Accreditation & Standards",
    id: "13",
  },
  {
    title: "Testing and Certification Services for Engineers",
    date: "24 February 2021",
    year: 2021,
    tag: "Environmental protection",
    id: "14",
  },
  {
    title:
      "“Underground Utility Survey Based on Nondestructive Testing, Surveying, Imaging and Diagnostic (NDTSID) Approaches” Webinar",
    date: "5 January 2021",
    year: 2021,
    tag: "Inspection",
    id: "15",
  },
  {
    title:
      "“Professional Integrity and Corruption Prevention in Testing and Certification” Webinar",
    date: "30 July 2020",
    year: 2020,
    tag: "Integrity & Professional Development",
    id: "16",
  },
  {
    title: "Metrology Symposium 2020",
    date: "10 January 2020",
    year: 2020,
    tag: "Metrology, Accreditation & Standards",
    id: "17",
  },
  {
    title: "Product Certification on Construction Materials",
    date: "21 November 2019",
    year: 2019,
    tag: "Construction materials",
    id: "18",
  },
  {
    title: "Research and Development of Chinese Medicines 2019",
    date: "24 September 2019",
    year: 2019,
    tag: "Chinese medicines",
    id: "19",
  },
  {
    title:
      "World Metrology Day (WMD), World Accreditation Day (WAD) and World Standards Day (WSD) Forum 2019",
    date: "26 June 2019",
    year: 2019,
    tag: "Metrology, Accreditation & Standards",
    id: "20",
  },
  {
    title: "Professional Ethics and Integrity in Testing and Certification",
    date: "19 June 2019",
    year: 2019,
    tag: "Integrity & Professional Development",
    id: "21",
  },
  {
    title:
      "New Opportunities for Testing and Certification in the Age of Technology",
    date: "18 March 2019",
    year: 2019,
    tag: "General Support",
    id: "22",
  },
  {
    title: "Testing and Certification for Food Safety",
    date: "5 March 2019",
    year: 2019,
    tag: "Food",
    id: "23",
  },
  {
    title: "Metrology Symposium 2019",
    date: "11 January 2019",
    year: 2019,
    tag: "Metrology, Accreditation & Standards",
    id: "24",
  },
  {
    title:
      "Underground Utility Survey Based on Nondestructive Testing, Surveying, Imaging and Diagnostic (NDTSID) Approaches",
    date: "10 January 2019",
    year: 2019,
    tag: "Construction materials",
    id: "25",
  },
  {
    title: "Latest Development of Certification",
    date: "7 January 2019",
    year: 2019,
    tag: "Quality Management",
    id: "26",
  },
  {
    title: "Research and Development of Chinese Medicines 2018",
    date: "19 September 2018",
    year: 2018,
    tag: "Chinese medicines",
    id: "27",
  },
  {
    title: "Cybersecurity Testing",
    date: "12 July 2018",
    year: 2018,
    tag: "Information & Communication Technologies",
    id: "28",
  },
  {
    title:
      "The World Metrology Day (WMD), World Accreditation Day (WAD) and World Standards Day (WSD) Forum 2018",
    date: "11 July 2018",
    year: 2018,
    tag: "Metrology, Accreditation & Standards",
    id: "29",
  },
  {
    title:
      "Anti-corruption Workshop for Testing and Certification Organisations",
    date: "29 June 2018",
    year: 2018,
    id: "30",
  },
  {
    title: "Latest Development of Testing and Certification under CEPA",
    date: "31 January 2018",
    year: 2018,
    tag: "CEPA & Mainland Opportunities",
    id: "31",
  },
  {
    title:
      "Latest Development of Construction Materials Testing, Inspection and Certification",
    date: "26 January 2018",
    year: 2018,
    tag: "Construction materials",
    id: "32",
  },
  {
    title: "Testing and Certification for Environmental Excellence",
    date: "18 December 2017",
    year: 2017,
    tag: "Environmental protection",
    id: "33",
  },
  {
    title: "Support to the Testing and Certification Industry",
    date: "16 November 2017",
    year: 2017,
    tag: "General Support",
    id: "34",
  },
  {
    title: "Metrology Symposium 2017",
    date: "27 October 2017",
    year: 2017,
    tag: "Metrology, Accreditation & Standards",
    id: "35",
  },
  {
    title: "Research and Development of Chinese Medicines 2017",
    date: "12 September 2017",
    year: 2017,
    tag: "Chinese medicines",
    id: "36",
  },
  {
    title:
      "Integrity and Professional Development in Testing and Certification Industry",
    date: "10 July 2017",
    year: 2017,
    tag: "Integrity & Professional Development",
    id: "37",
  },
  {
    title:
      "Testing and Certification of Wireless and Telecommunication Products",
    date: "28 June 2017",
    year: 2017,
    tag: "Consumer Products",
    id: "38",
  },
  {
    title:
      "The World Metrology Day (WMD), World Accreditation Day (WAD) and World Standards Day (WSD) Forum 2017",
    date: "6 June 2017",
    year: 2017,
    tag: "Metrology, Accreditation & Standards",
    id: "39",
  },
  {
    title: "Testing and Certification Services for Engineers",
    date: "1 March 2017",
    year: 2017,
    tag: "Environmental protection",
    id: "40",
  },
  {
    title: "Support to SME from Testing and Certification",
    date: "19 January 2017",
    year: 2017,
    tag: "General Support",
    id: "41",
  },
  {
    title: "Food Testing and Certification",
    date: "8 December 2016",
    year: 2016,
    tag: "Food",
    id: "42",
  },
  {
    title: "Metrology Symposium 2016",
    date: "28 October 2016",
    year: 2016,
    tag: "Metrology, Accreditation & Standards",
    id: "43",
  },
  {
    title:
      "Workshop on ISO/IEC 27001 Information Security Management System Certification 2016",
    date: "26 October 2016",
    year: 2016,
    tag: "Information & Communication Technologies",
    id: "44",
  },
  {
    title: "Testing and Certification for Fire Safety in Buildings",
    date: "19 October 2016",
    year: 2016,
    tag: "Construction materials",
    id: "45",
  },
  {
    title:
      "Accreditation for Medical Laboratories - The Road Towards Quality and Competence",
    date: "12 October 2016",
    year: 2016,
    tag: "Medical",
    id: "46",
  },
  {
    title: "Research and Development of Chinese Medicines 2016",
    date: "20 September 2016",
    year: 2016,
    tag: "Chinese medicines",
    id: "47",
  },
  {
    title:
      "Certification and Testing, Professionalization and Internationalization of Business Practice in the Fei Cui Jewellery Industry",
    date: "17 September 2016",
    year: 2016,
    tag: "Jewellery",
    id: "48",
  },
  {
    title: "Integrity Management in Testing and Certification Industry",
    date: "27 June 2016",
    year: 2016,
    tag: "Integrity & Professional Development",
    id: "49",
  },
  {
    title:
      "The World Metrology Day (WMD), World Accreditation Day (WAD) and World Standards Day (WSD) 2016",
    date: "8 June 2016",
    year: 2016,
    tag: "Metrology, Accreditation & Standards",
    id: "50",
  },
  {
    title: "Chinese Medicines Testing and Certification",
    date: "1 March 2016",
    year: 2016,
    tag: "Chinese medicines",
    id: "51",
  },
  {
    title: "Quality Management and Quality Assurance",
    date: "1 December 2015",
    year: 2015,
    tag: "Quality Management",
    id: "52",
  },
  {
    title: "Conference on ISO 9001:2015",
    date: "25 November 2015",
    year: 2015,
    tag: "Quality Management",
    id: "53",
  },
  {
    title: "Product Certification on Construction Materials",
    date: "13 November 2015",
    year: 2015,
    tag: "Construction materials",
    id: "54",
  },
  {
    title: "Research and Development of Chinese Medicines 2015",
    date: "10-11 September 2015",
    year: 2015,
    tag: "Chinese medicines",
    id: "55",
  },
  {
    title: "Professional Integrity in Testing and Certification",
    date: "13 July 2015",
    year: 2015,
    tag: "Integrity & Professional Development",
    id: "56",
  },
  {
    title: "Sharing on R&D Projects of Medical Testing",
    date: "6 July 2015",
    year: 2015,
    tag: "Medical",
    id: "57",
  },
  {
    title:
      "Mainland Opportunities for Hong Kong's Testing and Certification Industry",
    date: "26 June 2015",
    year: 2015,
    tag: "CEPA & Mainland Opportunities",
    id: "58",
  },
  {
    title:
      "Workshop on ISO/IEC 27001 Information Security Management System Certification",
    date: "19 June 2015",
    year: 2015,
    tag: "Information & Communication Technologies",
    id: "59",
  },
  {
    title:
      "The World Metrology Day (WMD), World Accreditation Day (WAD) and World Standards Day (WSD) 2015",
    date: "29 May 2015",
    year: 2015,
    tag: "Metrology, Accreditation & Standards",
    id: "60",
  },
  {
    title: "Gold Testing and Gemstone Authentication in Hong Kong",
    date: "17 March 2015",
    year: 2015,
    tag: "Jewellery",
    id: "61",
  },
  {
    title: "Healthy Life and Food Testing and Certification",
    date: "9 March 2015",
    year: 2015,
    tag: "Food",
    id: "62",
  },
  {
    title: "Greenhouse Gas Validation and Verification",
    date: "5 February 2015",
    year: 2015,
    tag: "Environmental protection",
    id: "63",
  },
];
